import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { AUTH_PATH } from 'src/constants/app.const';
const PrivateRoute = ({ children }) => {
    const isLogged = useSelector((state) => state.user.isLogged);
    return isLogged ? children : <Navigate to={AUTH_PATH + '/login'} />;
};

export default PrivateRoute;
